import {isNil} from 'ramda';

import {getSafely} from 'shared/web';

import {PriceReportType} from '../../../../../types/PriceReportType';
import {getVehiclePriceChangeDirection} from '../../../../../utils/getVehiclePriceChangeDirection';
import {
  CHART_TOOLBAR_HIGHLIGHT_KEYS,
  ChartToolbarHighlight,
  ChartToolbarHighlights,
} from '../types/ChartToolbarHighlight';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';
import {hasActiveChartToolbarFilters} from './hasActiveChartToolbarHighlights';
import {isNewVehicleInAdvertisement} from './isNewVehicleInAdvertisement';
import {isPrivateSeller} from './isPrivateSeller';
import {isVehicleMatchingSelectedSeller} from './isVehicleMatchingSelectedSeller';

function matchesChartToolbarHighlight(
  car: ExtendedStatisticsCar,
  highlight: ChartToolbarHighlight,
  priceReport: PriceReportType
) {
  return (
    (highlight === 'new' && isNewVehicleInAdvertisement(car)) ||
    (highlight === 'suspicious' && car.suspicious === true) ||
    (highlight === 'repriced' && !isNil(getVehiclePriceChangeDirection(car, priceReport))) ||
    (highlight === 'sellerType' && isPrivateSeller(car))
  );
}

export function isVehicleInHighlightedGroup(
  car: ExtendedStatisticsCar,
  highlights: ChartToolbarHighlights,
  priceReport: PriceReportType,
  selectedSellerId: string | null = null
) {
  if (!hasActiveChartToolbarFilters(highlights, selectedSellerId)) {
    return true;
  }

  if (car.isMyVehicle || car.isMyAd) {
    return true;
  }

  return (
    isVehicleMatchingSelectedSeller(car, selectedSellerId) ||
    CHART_TOOLBAR_HIGHLIGHT_KEYS.some(
      (highlight) =>
        getSafely(highlights, highlight, false) &&
        matchesChartToolbarHighlight(car, highlight, priceReport)
    )
  );
}
